var _AggregateLogger_loggers;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import AggregateDisposable from "../AggregateDisposable";
export default class AggregateLogger {
    constructor(...loggers) {
        _AggregateLogger_loggers.set(this, void 0);
        __classPrivateFieldSet(this, _AggregateLogger_loggers, loggers, "f");
    }
    debug(msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f"))
            logger.debug(msg, ...args);
    }
    debugError(err, msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f")) {
            if (msg) {
                logger.debugError(err, msg, ...args);
            }
            else {
                logger.debugError(err, ...args);
            }
        }
    }
    error(msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f"))
            logger.error(msg, ...args);
    }
    errorError(err, msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f")) {
            if (msg) {
                logger.errorError(err, msg, ...args);
            }
            else {
                logger.errorError(err, ...args);
            }
        }
    }
    info(msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f"))
            logger.info(msg, ...args);
    }
    infoError(err, msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f")) {
            if (msg) {
                logger.infoError(err, msg, ...args);
            }
            else {
                logger.infoError(err, ...args);
            }
        }
    }
    trace(msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f"))
            logger.trace(msg, ...args);
    }
    traceError(err, msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f")) {
            if (msg) {
                logger.traceError(err, msg, ...args);
            }
            else {
                logger.traceError(err, ...args);
            }
        }
    }
    warn(msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f"))
            logger.warn(msg, ...args);
    }
    warnError(err, msg, ...args) {
        for (const logger of __classPrivateFieldGet(this, _AggregateLogger_loggers, "f")) {
            if (msg) {
                logger.warnError(err, msg, ...args);
            }
            else {
                logger.warnError(err, ...args);
            }
        }
    }
    scope(name) {
        const scopedLoggers = __classPrivateFieldGet(this, _AggregateLogger_loggers, "f").map(logger => logger.scope(name));
        const disposable = new AggregateDisposable(...scopedLoggers);
        const aggLogger = new AggregateLogger(...scopedLoggers);
        return Object.assign(aggLogger, disposable);
    }
}
_AggregateLogger_loggers = new WeakMap();
